module.exports = __webpack_public_path__ + "img/Misi Working Style-Icon Realistic0.d0f805c7.png";